import GuidanceRegistry from '../guidance-registry.js';

GuidanceRegistry.register({
    type: "action-item-ewf-guided-setup-hra-plan-funding",
    prompt: getPrompt,
    briefDescription: 'HRA Plan Funding',
    openAction: {
        text: "View Plan Funding",
        url: (guidanceItem) => `/employer/${guidanceItem.employerId}/plans?planId=${guidanceItem.parameters.planId}`,
        row: "Funding"
    },
    completeAction: {
    }
});

function getPrompt(guidanceItem){       
    if(guidanceItem.parameters.isMedicalHra)
        return `Select your ${guidanceItem.parameters.planShortName} rollover settings. Then indicate if there is an Out of Pocket (OOP) amount that Ameriflex should track (which is the amount that a participant pays before being able to access the ${guidanceItem.parameters.planShortName} funds). Enter that desired OOP amount for one or more tiers (Single, EE/Spouse, etc). If the ${guidanceItem.parameters.planShortName} can be accessed on the first day of the plan year, there is no OOP amount for Ameriflex to track. Last, update any other coverage tiers and funding information for the ${guidanceItem.parameters.planShortName}. Click Save.`;
    else
        return `Select your ${guidanceItem.parameters.planShortName} rollover settings. Click Save.`
    
}



// WEBPACK FOOTER //
// ./src/guidance/items/guidance-hra-plan-funding.js